/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

/**
 * Standard error response object
 */
export type PutApiLeadScraperMicroserviceApiV1OrganizationsTenantsErrorResponseData =
  {
    error: string;
    code?: string | undefined;
    details?: any | null | undefined;
  };

/**
 * Standard error response object
 */
export class PutApiLeadScraperMicroserviceApiV1OrganizationsTenantsErrorResponse
  extends Error
{
  error: string;
  code?: string | undefined;
  details?: any | null | undefined;

  /** The original data that was passed to this error instance. */
  data$:
    PutApiLeadScraperMicroserviceApiV1OrganizationsTenantsErrorResponseData;

  constructor(
    err:
      PutApiLeadScraperMicroserviceApiV1OrganizationsTenantsErrorResponseData,
  ) {
    const message = "message" in err && typeof err.message === "string"
      ? err.message
      : `API error occurred: ${JSON.stringify(err)}`;
    super(message);
    this.data$ = err;

    this.error = err.error;
    if (err.code != null) this.code = err.code;
    if (err.details != null) this.details = err.details;

    this.name =
      "PutApiLeadScraperMicroserviceApiV1OrganizationsTenantsErrorResponse";
  }
}

/** @internal */
export const PutApiLeadScraperMicroserviceApiV1OrganizationsTenantsErrorResponse$inboundSchema:
  z.ZodType<
    PutApiLeadScraperMicroserviceApiV1OrganizationsTenantsErrorResponse,
    z.ZodTypeDef,
    unknown
  > = z.object({
    error: z.string(),
    code: z.string().optional(),
    details: z.nullable(z.any()).optional(),
  })
    .transform((v) => {
      return new PutApiLeadScraperMicroserviceApiV1OrganizationsTenantsErrorResponse(
        v,
      );
    });

/** @internal */
export type PutApiLeadScraperMicroserviceApiV1OrganizationsTenantsErrorResponse$Outbound =
  {
    error: string;
    code?: string | undefined;
    details?: any | null | undefined;
  };

/** @internal */
export const PutApiLeadScraperMicroserviceApiV1OrganizationsTenantsErrorResponse$outboundSchema:
  z.ZodType<
    PutApiLeadScraperMicroserviceApiV1OrganizationsTenantsErrorResponse$Outbound,
    z.ZodTypeDef,
    PutApiLeadScraperMicroserviceApiV1OrganizationsTenantsErrorResponse
  > = z.instanceof(
    PutApiLeadScraperMicroserviceApiV1OrganizationsTenantsErrorResponse,
  )
    .transform(v => v.data$)
    .pipe(z.object({
      error: z.string(),
      code: z.string().optional(),
      details: z.nullable(z.any()).optional(),
    }));

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PutApiLeadScraperMicroserviceApiV1OrganizationsTenantsErrorResponse$ {
  /** @deprecated use `PutApiLeadScraperMicroserviceApiV1OrganizationsTenantsErrorResponse$inboundSchema` instead. */
  export const inboundSchema =
    PutApiLeadScraperMicroserviceApiV1OrganizationsTenantsErrorResponse$inboundSchema;
  /** @deprecated use `PutApiLeadScraperMicroserviceApiV1OrganizationsTenantsErrorResponse$outboundSchema` instead. */
  export const outboundSchema =
    PutApiLeadScraperMicroserviceApiV1OrganizationsTenantsErrorResponse$outboundSchema;
  /** @deprecated use `PutApiLeadScraperMicroserviceApiV1OrganizationsTenantsErrorResponse$Outbound` instead. */
  export type Outbound =
    PutApiLeadScraperMicroserviceApiV1OrganizationsTenantsErrorResponse$Outbound;
}
